import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'

import StackedLineChartView from '../charts/StackedLineChartView'
import { timeseriesConfig } from '../../utils/TimeseriesConfig'

class CommunityChartView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    events: PropTypes.object.isRequired,
    timeseries: PropTypes.array.isRequired,
    units: PropTypes.object.isRequired,
  }

  static styles = () => ({
    title: {
      textAlign: 'center',
    },
  })

  unitName(unitId) {
    const unit = this.props.units[unitId] || { name: unitId }
    return unit.name
  }

  render() {
    const {
      classes, events, timeseries, units, ...props
    } = this.props

    const labeledData = {}
    timeseries.forEach((ts) => {
      const data = []
      events[ts.id].forEach((event) => {
        data.push({
          x: moment(event.timestamp),
          y: event.avg,
        })
      })
      labeledData[this.unitName(ts.unit_id)] = data
    })

    if (timeseries.length > 0) {
      // We are making an assumption about events being all the same type
      const tsConfig = timeseriesConfig(timeseries[0].name)
      return (
        <>
          <Typography variant="subtitle1" className={classes.title}>{timeseries[0].title}</Typography>
          <StackedLineChartView
            data={labeledData}
            formatter={(v) => tsConfig.format(v, tsConfig.convert)}
            {...tsConfig.chart}
            {...props}
          />
        </>
      )
    }
    return null
  }
}

export default withStyles(CommunityChartView.styles)(CommunityChartView)
